import { Router } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import {
  TopToolbar,
  useListContext,
  sanitizeListRestProps,
  ListButton,
  Error as RaError,
  Filter,
  Datagrid,
  TextField,
  List,
} from "react-admin";
import { useParams } from "react-router-dom";
import { CustomResourceRouteParams } from "../../../common/types";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { ShowEldMessageDetailsMenuItem } from "./ShowEldMessageDetailsMenuItem";
import ProLogsDateField from "../../common/data-grid-fields/ProLogsDateField";

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { basePath } = useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <ListButton
        basePath={basePath}
        label="resources.common.labels.backToList"
      />
    </TopToolbar>
  );
};

const ListFilter = (props: any) => {
  return (
    <Filter {...props}>
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        className="logs-list-view-filter"
        label="resources.hos-logs.labels.dateFrom"
        source="dateFrom"
        alwaysOn
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        className="logs-list-view-filter"
        label="resources.hos-logs.labels.dateTo"
        source="dateTo"
        alwaysOn
      />
    </Filter>
  );
};

export const EldMessagesList = (props: any) => {
  const params = useParams<CustomResourceRouteParams>();
  if (!params["id"]) {
    return <RaError error={new Error()} />;
  }
  return (
    <div className="content-container">
      <List
        empty={<ProLogsEmpty iconType={Router} />}
        className="content-list"
        title={`Geometris messages for ELD ${params["id"]}`}
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        filter={{ eldSerialNumber: params["id"] }}
        pagination={false}
        {...props}
      >
        <Datagrid>
          <ProLogsDateField source="timestamp" showTime sortable={false} />
          <TextField source="message" sortable={false} />
          <ActionsField editable={() => false}>
            <ShowEldMessageDetailsMenuItem />
          </ActionsField>
        </Datagrid>
      </List>
    </div>
  );
};
